export const HEADERS = [
  'HEADER.ID',
  'HEADER.USER-EMAIL',
  'HEADER.BANK',
  'HEADER.ACCOUNT-NUMBER',
];
